import * as React from "react"
import SaHomeImageFaq from "./saHomeImageFaq"
// @ts-ignore
import { saHomeImageFaqSection } from './saHomeImageFaq.module.scss'
import { saInterfaceImageTextFaq } from "../saTypes"
import { useLocation } from "@reach/router"



export const SaHomeImageFaqContainer:React.FC<Array<saInterfaceImageTextFaq>> = (props) => {


    let classes : string = ''
    const path = useLocation()

    if (path.pathname === '/'){
      classes = saHomeImageFaqSection
    }

    return (
      <section  id={'saHomeImageFaqSection'}
                className={classes}
      >
        <SaHomeImageFaq {...props}/>
      </section>
    )

}
